export const PURCHASE_IMPORT_SHIPMENT_PERMISSION = {
  VIEW: 'SL_PURCHASEIMPORT_VIEW',
  ADD: 'SL_PURCHASEIMPORT_ADD',
  EDIT: 'SL_PURCHASEIMPORT_EDIT',
  DEL: 'SL_PURCHASEIMPORT_DEL',
};

export const IMPORT_SHIPMENT_STATUS = {
  DRAFT: 'DRAFT',
  CONTRACTED: 'CONTRACTED',
  PAID: 'PAID',
  DECLARED: 'DECLARED',
  TAX_PAID: 'TAX_PAID',
  COST_ALLOCATED: 'COST_ALLOCATED',
  STOCKED: 'STOCKED',
  ACCOUNTED: 'ACCOUNTED',
  CLOSED: 'CLOSED',
};

export const IMPORT_SHIPMENT_STATUS_OPTIONS = [
  { value: IMPORT_SHIPMENT_STATUS.DRAFT, label: 'Nháp' },
  { value: IMPORT_SHIPMENT_STATUS.CONTRACTED, label: 'Đã ký hợp đồng' },
  { value: IMPORT_SHIPMENT_STATUS.PAID, label: 'Đã thanh toán' },
  { value: IMPORT_SHIPMENT_STATUS.DECLARED, label: 'Đã mở tờ khai' },
  { value: IMPORT_SHIPMENT_STATUS.TAX_PAID, label: 'Đã nộp thuế' },
  { value: IMPORT_SHIPMENT_STATUS.COST_ALLOCATED, label: 'Đã phân bổ chi phí' },
  { value: IMPORT_SHIPMENT_STATUS.STOCKED, label: 'Đã nhập kho' },
  { value: IMPORT_SHIPMENT_STATUS.ACCOUNTED, label: 'Đã hạch toán' },
  { value: IMPORT_SHIPMENT_STATUS.CLOSED, label: 'Đã khóa hồ sơ' },
];

export const IMPORT_DOCUMENT_TYPE_OPTIONS = [
  { value: 'CONTRACT', label: 'Hợp đồng' },
  { value: 'INVOICE', label: 'Invoice' },
  { value: 'PACKING_LIST', label: 'Packing list' },
  { value: 'BL', label: 'B/L' },
  { value: 'CO', label: 'C/O' },
  { value: 'CQ', label: 'C/Q' },
  { value: 'CUSTOMS_DECLARATION', label: 'Tờ khai' },
  { value: 'TAX_PAYMENT', label: 'Giấy nộp thuế' },
  { value: 'QUALITY_REGISTRATION', label: 'Đăng ký kiểm tra chất lượng' },
  { value: 'LOCAL_INVOICE', label: 'Hóa đơn local charge' },
  { value: 'OTHER', label: 'Khác' },
];

export const IMPORT_DOCUMENT_STATUS_OPTIONS = [
  { value: 'PENDING', label: 'Chờ kiểm tra' },
  { value: 'VALID', label: 'Hợp lệ' },
  { value: 'MISSING', label: 'Thiếu' },
  { value: 'REJECTED', label: 'Không hợp lệ' },
];

export const IMPORT_ACCOUNTING_CHECKLIST_OPTIONS = [
  { value: 'PAYMENT_RECORDED', label: 'Ghi nhận thanh toán/ứng trước NCC' },
  { value: 'CUSTOMS_DECLARED', label: 'Ghi nhận tờ khai hải quan' },
  { value: 'IMPORT_TAX_PAID', label: 'Nộp thuế nhập khẩu' },
  { value: 'IMPORT_VAT_RECORDED', label: 'Ghi nhận VAT nhập khẩu khấu trừ' },
  { value: 'LANDED_COST_ALLOCATED', label: 'Phân bổ chi phí về kho' },
  { value: 'STOCK_RECEIVED', label: 'Nhập kho theo landed cost' },
  { value: 'ACCOUNTING_POSTED', label: 'Post bút toán kế toán' },
];

export const IMPORT_COST_GROUP_OPTIONS = [
  { value: 'PRE_CUSTOMS', label: 'Chi phí trước thông quan', affects_inventory_cost: 1 },
  { value: 'INBOUND', label: 'Vận chuyển/giao nhận về kho', affects_inventory_cost: 1 },
  { value: 'IMPORT_DUTY', label: 'Thuế nhập khẩu', affects_inventory_cost: 1 },
  { value: 'OTHER_CAPITALIZED', label: 'Chi phí vốn hóa khác', affects_inventory_cost: 1 },
  { value: 'NON_CAPITALIZED', label: 'Chi phí không vốn hóa', affects_inventory_cost: 0 },
];

export const ALLOCATION_METHOD_OPTIONS = [
  { value: 'VALUE', label: 'Theo trị giá' },
  { value: 'QUANTITY', label: 'Theo số lượng' },
  { value: 'WEIGHT', label: 'Theo trọng lượng' },
  { value: 'MANUAL', label: 'Nhập tay' },
];

export const getOptionLabel = (options, value) => options.find((item) => item.value === value)?.label || value || '';

export const buildDefaultDocuments = (documentTypeOptions = IMPORT_DOCUMENT_TYPE_OPTIONS) =>
  documentTypeOptions.filter((item) => item.value !== 'OTHER').map((item) => ({
    document_type_code: item.value,
    check_status_code: 'PENDING',
  }));

export const buildDefaultChecklist = () =>
  IMPORT_ACCOUNTING_CHECKLIST_OPTIONS.map((item) => ({
    checklist_code: item.value,
    is_done: 0,
  }));
